import { render, staticRenderFns } from "./RecipientDomiciliation.vue?vue&type=template&id=76fd91e6&scoped=true&"
import script from "./RecipientDomiciliation.vue?vue&type=script&lang=js&"
export * from "./RecipientDomiciliation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fd91e6",
  null
  
)

export default component.exports